import React from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { MiniModalPropsInternal } from '../common/types/shared-types';

const LazyAIMiniModal = React.lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_ai-mini-modal" */ './main').then((module) => ({
		default: module.AIMiniModal,
	})),
);

export const AIMiniModal = (props: MiniModalPropsInternal) => (
	<React.Suspense fallback={null}>
		<LazyAIMiniModal {...props} />
	</React.Suspense>
);
